import type { ReactNode } from "react";
import { classNames } from "./internal/class-names";
import { OperationalIcon } from "./operational-icon";

export interface ErrorStateProps {
  readonly title: ReactNode;
  /**
   * Resolved, human-readable explanation. Stores expose error *codes*; the
   * calling view maps a code to text. Never pass a raw server message.
   */
  readonly description?: ReactNode | undefined;
  /** Retry or recovery control. */
  readonly action?: ReactNode | undefined;
  readonly className?: string | undefined;
}

/** Failure notice. Uses `role="alert"` so the outcome is announced immediately. */
export function ErrorState({ action, className, description, title }: ErrorStateProps): ReactNode {
  return (
    <div className={classNames("thw-state", "thw-state--error", className)} role="alert">
      <p className="thw-state__title">
        <OperationalIcon name="warning" />
        {title}
      </p>
      {description === undefined ? null : (
        <p className="thw-state__description">{description}</p>
      )}
      {action}
    </div>
  );
}
